// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: "AIzaSyALRzAqIliuiSw_KuTTtwaD19szXe0tWCc",
        authDomain: "isales-toolbox.firebaseapp.com",
        databaseURL: "https://isales-toolbox.firebaseio.com",
        projectId: "isales-toolbox",
        storageBucket: "isales-toolbox.appspot.com",
        messagingSenderId: "911103474743",
        appId: "1:911103474743:web:4532393ef7b078fda813b2"
    }
};
